import React, { useState, useEffect } from "react";
import {
  defineRecommendationType,
  definePluralOrSingular,
  fetchInsights,
  fetchConsiderations,
  // getHighestCurrentPercentEmotion,
  getHighestChange,
  checkRecData,
  randomInteger
} from "./Recommendations";

export const getApplicableAction = (type,actionCounts) => {
  // remove action "Other" from actionCounts
  let filteredActionCounts = actionCounts.filter(action => action.name !== "Other");
  if(type === "Frequency") {
    // Get Action with the highest current percent
    filteredActionCounts.sort((a, b) => b.current - a.current);
    return filteredActionCounts[0].name;
  } else {
    // Get Action with the highest change
    filteredActionCounts.sort((a, b) => b.change - a.change);
    return filteredActionCounts[0].name;
  }
};

const BoostBehaviour = ({
  selectedRecommendationTab,
  actionCounts,
  chosenTime,
  state,
}) => {
  // Define required state variables
  const [insights, setInsights] = useState("");
  const [recommendationType, setRecommendationType] = useState("");
  const [applicableEmotion, setApplicableEmotion] = useState("");
  const [pluralOrSingular, setPluralOrSingular] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [considerations, setConsiderations] = useState("");

  const getHighestCurrentPercentEmotion = (actionCounts) => {
    // Remove

    actionCounts.sort((a, b) => b.currentPercent - a.currentPercent);
    return actionCounts[0];
  };

  const processInsights = (insights, type) => {
    try {
      let action_percent = "75";
      if (type === "Frequency") {
        // structure the data for the insights
        let changes = getHighestCurrentPercentEmotion(actionCounts);
        action_percent = changes.currentPercent;
      } else if (type === "Change") {
        let highestChange = getHighestChange(actionCounts);
        action_percent = highestChange.change;
      }

      // Set the emotion percent
      // setEmotionPercent(emotion_percent)

      // Replace the # with the emotion percent
      let original_insights = insights.insights;
      let new_insights = original_insights.replace("#", action_percent);

      // Replace the NAME with the chosen student name
      if (state.chosenStudent != "All Students") {
        const actual_name =
          state.studentEmailToNameMap[state.chosenStudent] ||
          state.chosenStudent;
        new_insights = new_insights.replace("NAME", actual_name);
      }

      // Now set the Insights
      setInsights(new_insights);
    } catch (error) {
      setInsights("No insights found");
    }
  };

  const getRecommendations = async () => {
    try {
      if (!checkRecData(actionCounts)) {
        setInsights("--");
        setConsiderations("--");
        return;
      }

      setIsLoading(true);

      // Get all values synchronously
      const type = defineRecommendationType();
      const action = getApplicableAction(type,actionCounts);
      
      // Define weather plural or singular
      let isPlural = true;
      if (state.chosenStudent && (state.chosenStudent != "All Students" && state.chosenStudent != "Choose Student")) {
        isPlural = false;
      }
      const plural_or_singular = definePluralOrSingular(isPlural);

      // Update states
      setRecommendationType(type);
      setApplicableEmotion(action);
      setPluralOrSingular(plural_or_singular);

      // Get recommendations from the backend
      const insightsResponse = await fetchInsights(
        action,
        type,
        plural_or_singular,
        selectedRecommendationTab
      );
      processInsights(insightsResponse, type, action);

      // Get considerations from the backend
      await fetchConsiderations(
        action,
        plural_or_singular,
        setConsiderations,
        selectedRecommendationTab
      );
    } catch (error) {
      setInsights("An error occurred while getting recommendations.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getRecommendations();
  }, [actionCounts]);

  return (
    <div className="flex flex-col gap-4">
      <div className="border-l-4 border-[#2D3748] pl-4">
        <h5 className="text-[12px] text-[#2D3748] font-semibold mb-2">DATA</h5>
        <p className="text-400 text-[16px] text-normal">{insights}</p>
      </div>

      <div className="border-l-4 border-[#005BE2] pl-4">
        <h5 className="text-[12px] text-[#005BE2] font-semibold mb-2">
          CONSIDER
        </h5>
        <div className="relative group">
          <p className="text-400 text-[16px] font-normal line-clamp-4">
            {considerations}
          </p>
          <div className="absolute top-0 left-0 hidden group-hover:block bg-white text-[16px] text-400 border border-gray-200 rounded-md shadow-lg p-3 z-20 w-full">
            {considerations}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoostBehaviour;
